import * as Website from '../Config/Website.js';

const Animation = () => {
  const targetElms = document.getElementsByClassName('js-anime');
  if (targetElms.length === 0) return;
  const threshold = {
    pc: Website.status.winHeight / 5,
    sp: Website.status.winHeight / 10,
  }


  for(const targetElm of targetElms) {
    let shift = 0;
    const position = targetElm.getBoundingClientRect().top;

    if(Website.status.winWidth < Website.options.shiftpoint) {
      shift = threshold.sp;
    } else {
      shift = threshold.pc;
    }

    if(targetElm.dataset.offsetRatio) {
      const ratio = targetElm.dataset.offsetRatio;
      if(-1 <= ratio && ratio <= 1) {
        shift = Website.status.winHeight * ratio;
      }
    }

    if(position < Website.status.winHeight - shift) {
      targetElm.classList.add('is-anime'); 
    } else {
      // targetElm.classList.remove('is-anime');
    }
  }
}

export default Animation;